// ---- Local Storage (ข้อมูลจะหายไปก็ต่อเมื่อ Clear Storage) ---- //
export const getLocalStorage = (key: string) => {
    const result: string = window.localStorage.getItem(key);
    return result;
};

export const setLocalStorage = (key: string, value: string) => {
    window.localStorage.setItem(key, value);
};

export const removeLocalStorage = (key: string) => {
    window.localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
    window.localStorage.clear();
};

// ---- Session Storage (ข้อมูลก็จะหายไปเมื่อปิด Browser) ---- //
export const getSessionStorage = (key: string) => {
    const result: string = window.sessionStorage.getItem(key);
    return result;
};

export const setSessionStorage = (key: string, value: string) => {
    window.sessionStorage.setItem(key, value);
};

export const removeSessionStorage = (key: string) => {
    window.sessionStorage.removeItem(key);
};

export const clearSessionStorage = () => {
    window.sessionStorage.clear();
};
